export default __webpack_public_path__ + "static/media/tuzhi-logo-reverse-trans.20e69255.png";